//MVP categories 
import { Image } from '@mantine/core';
import { Link } from 'react-router-dom';
import { Category } from 'TYPES/api.body';

interface Props {
  categories: Category[];
}

const makeSlug = (name: string) => name.toLowerCase().split(' ').join('-');

// Helper function to get fallback image based on category name
const getFallbackImage = (categoryName: string): string => {
  const name = categoryName.trim().toLowerCase();

  // Active categories
  if (name.includes('grocery') || name.includes('groceries') || name.includes('market')) {
    return '/images/categories/groceries.png';
  }
  if (name.includes('pharmacy') || name.includes('medical') || name.includes('health') || name.includes('medicine')) {
    return '/images/categories/pharmacy.png';
  }
  // Robust electronics/electrical matching
  if (
    name.includes('electronics') ||
    name.includes('tech') ||
    name.includes('gadget') ||
    name.includes('electrical accessories') ||
    (name.includes('electrical') && name.includes('accessories'))
  ) {
    return '/images/categories/electronics.png';
  }

  // Default fallback
  return '/images/categories/default.png';
};

// Helper function to check if category should be displayed
const shouldDisplayCategory = (categoryName: string): boolean => {
  const name = categoryName.toLowerCase();
  return (
    name.includes('grocery') ||
    name.includes('groceries') ||
    name.includes('market') ||
    name.includes('pharmacy') ||
    name.includes('medical') ||
    name.includes('health') ||
    name.includes('medicine') ||
    name.includes('electronics') ||
    name.includes('electrical') ||
    name.includes('accessories')
  );
};

const BlobFlex: React.FC<Props> = ({ categories }) => {
  // Filter categories to only show Grocery and Pharmacy
  const filteredCategories = categories.filter(category =>
    shouldDisplayCategory(category.name)
  );

  return (
    <div className="flex justify-center gap-14 padding-section py-24">
      {filteredCategories.map(category => (
        <div className="flex flex-col items-center group" key={category.id}>
          <Link
            className="flex flex-col items-center"
            to={`/categories/${makeSlug(category.name)}?category=${category.id}`}>
            <div className="mb-2 overflow-hidden">
              <Image
                src={category.logo || getFallbackImage(category.name)}
                alt={category.name}
                className="transition-transform duration-300 ease-in-out group-hover:scale-110 max-w-[200px] w-auto h-auto"
                onError={(e) => {
                  // If the primary image fails, use fallback
                  const target = e.target as HTMLImageElement;
                  if (target.src !== getFallbackImage(category.name)) {
                    target.src = getFallbackImage(category.name);
                  }
                }}
              />
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default BlobFlex;


//standard categories

// import { Image } from '@mantine/core';
// import { Link } from 'react-router-dom';
// import { Category } from 'TYPES/api.body';

// interface Props {
//   categories: Category[];
// }

// const makeSlug = (name: string) => name.toLowerCase().split(' ').join('-');

// // Helper function to get fallback image based on category name
// const getFallbackImage = (categoryName: string): string => {
//   const name = categoryName.toLowerCase();

//   if (name.includes('agriculture') || name.includes('farming')) {
//     return '/images/categories/agriculture.png';
//   }
//   if (name.includes('food') || name.includes('restaurant') || name.includes('grocery')) {
//     return '/images/categories/food.png';
//   }
//   if (name.includes('health') || name.includes('medical') || name.includes('beauty')) {
//     return '/images/categories/health.png';
//   }
//   if (name.includes('fashion') || name.includes('clothing') || name.includes('apparel')) {
//     return '/images/categories/fashion.png';
//   }
//   if (name.includes('electronics') || name.includes('tech') || name.includes('gadget')) {
//     return '/images/categories/electronics.png';
//   }
//   if (name.includes('home') || name.includes('furniture') || name.includes('decor')) {
//     return '/images/categories/home.png';
//   }
//   if (name.includes('supermarket') || name.includes('market') || name.includes('supermarket')) {
//     return '/images/categories/supermarket.png';
//   }
//   if (name.includes('lottery') || name.includes('games') || name.includes('gym')) {
//     return '/images/categories/lottery.png';
//   }
//   if (name.includes('automotive') || name.includes('car') || name.includes('vehicle')) {
//     return '/images/categories/auto.png';
//   }
//   if (name.includes('event') || name.includes('Occasion') || name.includes('party')) {
//     return '/images/categories/events.png';
//   }

//   // Default fallback
//   return '/images/categories/default.png';
// };

// const BlobFlex: React.FC<Props> = ({ categories }) => {
//   return (
//     <div className="md:flex md:justify-center gap-14 padding-section py-24 flex-wrap">
//       {categories.map(category => (
//         <div className="flex flex-col items-center" key={category.id}>
//           <Link
//             className="flex flex-col items-center"
//             to={`/categories/${makeSlug(category.name)}?category=${category.id}`}>
//             <div className="blob mb-2 border">
//               <Image
//                 src={category.logo || getFallbackImage(category.name)}
//                 alt={category.name}
//                 onError={(e) => {
//                   // If the primary image fails, use fallback
//                   const target = e.target as HTMLImageElement;
//                   if (target.src !== getFallbackImage(category.name)) {
//                     target.src = getFallbackImage(category.name);
//                   }
//                 }}
//               />
//             </div>
//           </Link>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default BlobFlex;


// import { Image } from '@mantine/core';
// import { blob } from 'components/molecules/blobs';
// import { Link } from 'react-router-dom';
// import { Category } from 'TYPES/api.body';

// interface Props {
//   categories: Category[];
// }

// const makeSlug = (name: string) => name.toLowerCase().split(' ').join('-');

// const BlobFlex: React.FC<Props> = ({ categories }) => {
//   return (
//     <div className="md:flex md:justify-center gap-14 padding-section py-24 flex-wrap">
//       {categories.map(category => (
//         <div className="flex flex-col items-center" key={category.id}>
//           <Link
//             className="flex flex-col items-center"
//             to={`/categories/${makeSlug(category.name)}?category=${category.id}`}>
//             <div className="blob mb-2 border border-[#000000] hover:border-blue-600">
//               <Image src={category.logo ?? blob} alt={category.name} />
//             </div>
//             <span className="text-[#4D4D4D]">{category.name}</span>
//           </Link>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default BlobFlex;